import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function CartInner() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const saved = JSON.parse(sessionStorage.getItem("cart")) || [];
    setCartItems(saved);
  }, []);

  const updateSession = (updated) => {
    setCartItems(updated);
    sessionStorage.setItem("cart", JSON.stringify(updated));
  };

  const updateQuantity = (id, amount) => {
    const updated = cartItems.map((item) =>
      item.id === id
        ? { ...item, quantity: Math.max(1, item.quantity + amount) }
        : item
    );
    updateSession(updated);
  };

  const removeItem = (id) => {
    const updated = cartItems.filter((item) => item.id !== id);
    updateSession(updated);
  };

  const getImage = (item) => {
    if (!item?.imageUrl) return "/assets/img/placeholder.png";
    return Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl;
  };

  const cartTotal = cartItems.reduce(
    (t, item) => t + item.price * item.quantity,
    0
  );

  if (cartItems.length === 0) {
    return (
      <div className="empty-cart">
        <h3>Your cart is empty 🛒</h3>
        <Link to="/shop" className="empty-btn">
          Browse Products
        </Link>

        <style>{`
          .empty-cart {
            padding: 120px 20px;
            text-align: center;
          }
          .empty-btn {
            background: #0b61d6;
            color: #fff;
            padding: 12px 22px;
            border-radius: 8px;
            display: inline-block;
            margin-top: 18px;
            text-decoration: none;
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="cart-wrapper">
      <div className="container">
        <h2 className="cart-title">Your Shopping Cart</h2>

        <div className="cart-grid">
          <div className="cart-left">
            {cartItems.map((item) => (
              <div className="cart-card" key={item.id}>
                <img
                  src={getImage(item)}
                  alt={item.name}
                  className="cart-img"
                />

                <div className="cart-info">
                  <Link
                    to={`/product-details/${item.id}`}
                    className="cart-name"
                  >
                    {item.name}
                  </Link>

                  <p className="cart-price">${item.price}</p>

                  <div className="cart-qty">
                    <button onClick={() => updateQuantity(item.id, -1)}>
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, 1)}>
                      +
                    </button>
                  </div>
                </div>

                <div className="cart-total-price">
                  ${(item.price * item.quantity).toFixed(2)}
                </div>

                <button
                  className="cart-remove"
                  onClick={() => removeItem(item.id)}
                >
                  ✕
                </button>
              </div>
            ))}

            <Link to="/shop" className="continue-btn">
              Continue Shopping
            </Link>
          </div>

          {/* RIGHT SUMMARY */}
          <div className="cart-summary">
            <h3>Order Summary</h3>

            <div className="summary-row">
              <span>Subtotal</span>
              <span>${cartTotal.toFixed(2)}</span>
            </div>

            <div className="summary-row total">
              <span>Total</span>
              <span>${cartTotal.toFixed(2)}</span>
            </div>

            <Link to="/checkout" className="checkout-btn">
              Proceed to Checkout
            </Link>
          </div>
        </div>
      </div>

      {/* === INLINE STYLING === */}
      <style>{`
        .cart-wrapper {
          padding: 40px 0;
        }

        .cart-title {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 25px;
        }

        .cart-grid {
          display: grid;
          grid-template-columns: 1.7fr 1fr;
          gap: 30px;
        }

        /* LEFT SIDE */
        .cart-card {
          display: flex;
          align-items: center;
          background: #fff;
          padding: 18px;
          border-radius: 14px;
          margin-bottom: 18px;
          box-shadow: 0px 4px 18px rgba(0,0,0,0.07);
          position: relative;
        }

        .cart-img {
          width: 100px;
          height: 100px;
          object-fit: contain;
          margin-right: 18px;
        }

        .cart-info {
          flex-grow: 1;
        }

        .cart-name {
          font-size: 17px;
          font-weight: 700;
          color: #222;
          text-decoration: none;
        }

        .cart-name:hover { color: #0b61d6; }

        .cart-price {
          margin: 6px 0;
          font-weight: 600;
        }

        .cart-qty {
          display: flex;
          gap: 10px;
          align-items: center;
          margin-top: 5px;
        }

        .cart-qty button {
          width: 30px;
          height: 30px;
          border: none;
          background: #e8e8e8;
          border-radius: 6px;
          font-size: 18px;
          cursor: pointer;
        }

        .cart-total-price {
          font-size: 18px;
          font-weight: 700;
          margin-left: 10px;
        }

        .cart-remove {
          position: absolute;
          right: 12px;
          top: 12px;
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          color: #999;
          transition: .2s;
        }

        .cart-remove:hover { color: #ff4b4b; }

        .continue-btn {
          display: inline-block;
          margin-top: 20px;
          background: #ddd;
          padding: 10px 22px;
          border-radius: 8px;
          color: #333;
          text-decoration: none;
        }

        /* SUMMARY BOX */
        .cart-summary {
          background: #fff;
          padding: 25px;
          border-radius: 14px;
          box-shadow: 0px 4px 18px rgba(0,0,0,0.06);
          height: max-content;
        }

        .cart-summary h3 {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
          font-size: 16px;
        }

        .summary-row.total {
          font-size: 18px;
          font-weight: 700;
          margin-top: 8px;
          padding-top: 8px;
          border-top: 1px solid #ddd;
        }

        .checkout-btn {
          display: block;
          background: #0b61d6;
          padding: 14px;
          text-align: center;
          border-radius: 10px;
          color: white;
          font-weight: 700;
          margin-top: 22px;
          text-decoration: none;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .cart-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 600px) {
          .cart-card {
            flex-direction: column;
            align-items: flex-start;
          }
          .cart-img {
            margin-bottom: 10px;
          }
          .cart-total-price {
            position: absolute;
            right: 15px;
            bottom: 15px;
          }
        }
      `}</style>
    </div>
  );
}

export default CartInner;
